import React from 'react';
import {connect} from 'react-redux';
import {
    cancelSyncVersionChange,
    requestSyncVersionUpdate,
    updateSyncVersion
} from '../../../../../actions/synchronisationActions';
import {NativeSelect, RHFField, rfRules} from '../../../../../components/Field';
import {required} from '../../../../../components/Field/validate';
import SyncVersionConfirmationModal from './SyncVersionConfirmationModal';

// Migrated to react-hook-form: registers `syncVersion` on the parent SyncForm's
// `control`. onValueChange fires the version-change confirmation flow only on user
// selection (RHFField does not call it on programmatic reset/setValue).
function SyncVersionField({ control, currentStore, initialValues, disabled, options, requestSyncVersion,setRequestSyncVersion, updateSyncVersion, cancelChanges, syncVersionModalOpen, schedulerData }) {

  function handleModalConfirmation() {
    updateSyncVersion(currentStore.id, requestSyncVersion, initialValues.id, schedulerData);
  }

  function handleModalClose() {
    cancelChanges(currentStore.id);
  }

  function handleSelectChange(value) {
    setRequestSyncVersion(value, initialValues.id);
  }

  return (
    <React.Fragment>
      <RHFField
        name="syncVersion"
        control={control}
        component={NativeSelect}
        className="px-1"
        id="syncVersion"
        rules={rfRules([required])}
        disabled={disabled}
        options={options}
        onValueChange={handleSelectChange}
      />

      <SyncVersionConfirmationModal
        isOpen={syncVersionModalOpen}
        handleModalConfirmation={() => { handleModalConfirmation(requestSyncVersion);}}
        handleModalClose={handleModalClose}
      />
    </React.Fragment>
  );
}

export default connect(
  state => ({
    requestSyncVersion: state.sync.source.requestSyncVersion,
    syncVersionModalOpen: state.sync.source.syncVersionModalOpen,
    schedulerData: state.sync.source.schedulerData
  }),
  dispatch => ({
    cancelChanges: () => dispatch(cancelSyncVersionChange()),
    setRequestSyncVersion: (syncVersion, sourceId) => dispatch(requestSyncVersionUpdate(syncVersion, sourceId)),
    updateSyncVersion: (realStoreId, syncVersion, sourceId, schedulerData) => dispatch(updateSyncVersion(realStoreId, syncVersion, sourceId, schedulerData)),
  })
)(SyncVersionField);